import { render, staticRenderFns } from "./tabsAttrDlg.vue?vue&type=template&id=73e72c5e&scoped=true&"
import script from "./tabsAttrDlg.vue?vue&type=script&lang=js&"
export * from "./tabsAttrDlg.vue?vue&type=script&lang=js&"
import style0 from "./tabsAttrDlg.vue?vue&type=style&index=0&id=73e72c5e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e72c5e",
  null
  
)

export default component.exports